import { LockdownGroupMessageSignalR, LockdownModelMessageSignalR } from '../../models/lockdown/lockdown';
import { AccessPointStatusSignalR } from '../../models/notification-payload';

export class LoadLockdownGroups {
  static readonly type = '[Lockdown] Load Lockdown Groups';

  constructor() {
  }
}

export class LockdownGroupOutputs {
  static readonly type = '[Lockdown] Locking down Group outputs';

  constructor(public lockForm: any) {
  }
}

export class GetSelectedGroupInfo {
  static readonly type = '[Lockdown] Load Selected Group Info';

  constructor(public lockdownId: string) {
  }
}

export class EndLockdown {
  static readonly type = '[Lockdown] End Lockdown For Group';

  constructor(public lockdownId: string) {
  }
}

export class SelectGroup {
  static type = '[Lockdown] Select Group';

  constructor(public groupId: number) {
  }
}

export class GetConfigurations {
  static type = '[Lockdown] Get server configurations';

  constructor() {
  }
}

export class LoadMoreResults {
  static type = '[Lockdown] Get more groups';

  constructor(public resetChunk: boolean = false) {
  }
}

export class UpdateSerchTerm {
  static type = '[Lockdown] Update searchTerm';

  constructor(public searchTerm: string = '') {
  }
}

export class UpdateLockdowns {
  static type = '[Lockdown] Update Lockdowns';
  constructor(public lockdownUpdate: LockdownGroupMessageSignalR) {
  }
}

export class UpdateSelectedLockdown {
  static type = '[Lockdown] Update Selected Lockdown';
  constructor(public selectedLockdownUpdate: LockdownModelMessageSignalR) {
  }
}

export class UpdateLockdownsByAccessPointStatus {
  static type = '[Lockdown] Update Lockdowns By Access Point Status';
  constructor(public accessPointStatusUpdate: AccessPointStatusSignalR) {
  }
}



